<template>
  <q-drawer
    bordered
    show-if-above
    :width="300"
    :mini="!drawerExpanded"
    v-model="appStore.drawerShow"
    :breakpoint="500"
  >
    <template v-slot:mini>
      <q-img
        @click="appStore.drawerExpanded = !appStore.drawerExpanded"
        src="../assets/app-logo.png"
        class="absolute-top"
        style="height: 150px"
      />
      <q-scroll-area>
        <div id="drawer" />
      </q-scroll-area>
    </template>

    <template v-slot:default>
      <q-img
        class="absolute-top"
        src="../assets/app-logo.png"
        style="height: 150px"
      >
        <!--<tjpa-info-menu class="absolute-bottom-right" />-->
      </q-img>

      <q-scroll-area>
        <q-list>
          <q-item>
            <q-item-section>
              <q-btn flat dense label="Incidente de Resolução de Demandas Repetitivas" @click="$router.push('/')"/>
            </q-item-section>
          </q-item>
          <q-item>
            <q-item-section>
              <q-btn flat dense label="Incidente de Assunção de Competência" @click="$router.push('/iachome')"/>
            </q-item-section>
          </q-item>
          <q-item-separator/>
          <q-item>
            <q-item-section>
              <q-btn flat dense label="Grupo de Representativos" @click="$router.push('/grhome')"/>
            </q-item-section>
          </q-item>
          <q-item>
            <q-item-section>
              <q-btn flat dense label="Pedido de Uniformização de Interpretação de Lei" @click="$router.push('/puilhome')"/>
            </q-item-section>
          </q-item>
          <q-item>
            <q-item-section>
              <q-btn flat dense label="Enunciados de Súmula" @click="$router.push('/sumulahome')"/>
            </q-item-section>
          </q-item>

        </q-list>
      </q-scroll-area>
    </template>
  </q-drawer>
</template>

<script setup>
import TjpaInfoMenu from "@/components/tjpa-info-menu.vue";
TjpaInfoMenu;
import { useAppStore } from "@/store/app-store";
import { computed } from "vue";

const appStore = useAppStore();
const drawerExpanded = computed(() => appStore.drawerExpanded);
//const appLogo = ref("https://cdn.quasar.dev/img/material.png");
</script>

<style lang="scss" scoped>
.q-scrollarea {
  height: calc(100% - 150px);
  margin-top: 150px;
}
</style>
